import {ColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {doValidateSmilesQuery} from 'notebook/structured-tables/molecules/ValidateSmilesDAO';
import {
  CustomResolutionQueryType,
  ServerResolutionResult,
  ValidateSmilesQuery,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {CustomEvalResult} from 'notebook/tables/TableConstants';
import {ResolutionQueryType} from 'notebook/tables/TableStoreTransforms';
import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {
  makeTypedValueFromCustomResolvedValue,
  ResolveQueryFn,
} from 'notebook/tables/typed-values/TypedValueResolution';

export async function bulkResolveValidateSmilesToServerResolutionResult(
  queries: Array<ValidateSmilesQuery>
): Promise<Array<ServerResolutionResult>> {
  const queryResult = await doValidateSmilesQuery(queries.map((query) => query.smilesString));
  return queryResult.serverResolutionResults;
}

export function smilesColumnCustomEval(
  typedValue: TypedValue,
  columnDefinition: ColumnDefinition,
  cellDependencies: Array<TypedValue | null>,
  customEvalOptions: unknown,
  resolveFromResolutionQuery: ResolveQueryFn
): CustomEvalResult {
  const smilesString = formatTypedValue(typedValue);

  const {resolvedValue, error} = resolveFromResolutionQuery(
    typedValue,
    {
      customResolutionQueryType: CustomResolutionQueryType.REGISTRATION_TABLE_VALIDATE_SMILES,
      smilesString,
      type: ResolutionQueryType.CUSTOM,
    },
    makeTypedValueFromCustomResolvedValue
  );
  return {val: resolvedValue, error, locked: false};
}
